import BaseService from './BaseService'

class PlatformService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  getPlatformTest = async () => {
    const response = this.requests.get(`/`)
    return response;
  }

}
 const instance = new PlatformService(BaseService.servicesConfig.Platform)


export default instance
